export default __webpack_public_path__ + "static/media/paladin.e28817c7.png";